import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { createPortal } from 'react-dom';
import createComponent, { register } from 'intergalactic/core';
import canUseDOM from 'intergalactic/utils/lib/canUseDOM';
import { getNodeByRef } from 'intergalactic/utils/lib/ref';

/** @deprecated */

var PortalContext = register.get('portal-context', /*#__PURE__*/React.createContext(canUseDOM() ? document.body : null));
function Portal(props) {
  var Children = props.Children,
    disablePortal = props.disablePortal,
    ignorePortalsStacking = props.ignorePortalsStacking,
    onMount = props.onMount;
  var container = React.useContext(PortalContext);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mountNode = _React$useState2[0],
    setMountNode = _React$useState2[1];
  React.useEffect(function () {
    if (disablePortal) return;
    onMount === null || onMount === void 0 ? void 0 : onMount(true);
    if (ignorePortalsStacking) {
      setMountNode(canUseDOM() ? document.body : null);
      return;
    }
    setMountNode(getNodeByRef(container));
  }, [container, disablePortal, onMount]);
  if (disablePortal) {
    return /*#__PURE__*/React.createElement(Children, null);
  }
  return mountNode ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(Children, null), mountNode) : null;
}
Portal.displayName = 'Portal';
var PortalProvider = PortalContext.Provider;
export { PortalProvider };
export default createComponent(Portal);
//# sourceMappingURL=Portal.js.map